import { formatMinRedeemUsd, isMinRedeemBypassed } from './rewards-config'

const minLabel = formatMinRedeemUsd()

/** BFP-300 — shown on disabled Redeem when balance is below `VITE_MIN_REDEEM_USD`. */
export const REWARDS_REDEEM_DISABLED_TOOLTIP = isMinRedeemBypassed
  ? 'You need a balance to redeem'
  : `Minimum balance of ${minLabel} required to access Rewards`

/** Null when platform minimum is disabled (`VITE_MIN_REDEEM_USD=0`). */
export const REWARDS_BALANCE_MIN_LINE: string | null = isMinRedeemBypassed
  ? null
  : `${minLabel} Minimum to redeem`

export const REDEEM_SUCCESS_TITLE = 'Reward Claimed'
export const REDEEM_SUCCESS_BODY =
  'Your reward has been redeemed successfully. View it in the Claimed tab.'
export const REDEEM_SUCCESS_OK = 'Ok'

/** TC-12B-64 — success toast after redemption. */
export const REDEEM_SUCCESS_TOAST = 'Reward was successfully created'

/** TC-12A-48 / TC-12B-69 — network or API failure during redemption. */
export const REDEEM_FAILURE_TOAST = 'Unable to process redemption. Please try again.'

/** TC-12B-87 — tooltip on disabled View button when gift card is processing. */
export const REWARD_PROCESSING_VIEW_TOOLTIP =
  "Your gift card is being processed. You'll be notified when it's ready."

/** TC-12B-51 — prefix for rate-limit countdown message shown inside the modal. */
export const REDEEM_RATE_LIMIT_PREFIX = 'Too many redemption requests. Please wait '
